var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-partner-box"},[_c('div',{staticClass:"mobile-en-title"},[_vm._v("COOPERATIVE PARTNER")]),_c('div',{staticClass:"mobile-cn-title"},[_vm._v("合作伙伴")])])
}]

export { render, staticRenderFns }